import ApiError from '../exceptions/ApiError';
import store from './../store';
import router from './../router';

class BaseProxy {
    constructor(endpoint, parameters = {}) {
        this.endpoint = endpoint;
        this.parameters = parameters;
    }

    async submit(requestType, url, params = null) {
        let request = null;

        try {
            if (['get', 'delete'].includes(requestType)) {
                request = window.axios[requestType](`${this.endpoint}${url}`, { params });
            } else {
                request = window.axios[requestType](`${this.endpoint}${url}`, params);
            }

            const response = await request;

            if (response.status >= 200 && response.status < 300) {
                return response.data;
            }
        } catch (e) {
            if (e.response !== undefined && e.response.status === 401 && url.substr(1).indexOf('login') === 1) {
                store.dispatch('auth/logout');
                router.push({
                    name: 'auth.login',
                    query: {
                        disabled: 'true',
                    }
                });
            } else {
                throw new ApiError({
                    status: e.response.status,
                    error: e.response.data,
                });
            }
        }

        return false;
    }

    show(id) {
        return this.submit('get', `/${id}`);
    }

    index(params = null) {
        return this.submit('get', '/', params);
    }

    destroy(id, params = null) {
        return this.submit('delete', `/${id}`, params);
    }

    update(id, params) {
        return this.submit('put', `/${id}`, params);
    }

    store(params) {
        return this.submit('post', '/', params);
    }
}

export default BaseProxy;



// WEBPACK FOOTER //
// ./src/api/BaseProxy.js